export function ofuscarJSON (o) {
	if (o === null || o === undefined) {
		return ''
	}

	let s = JSON.stringify(o)
	let b = btoa(encodeURIComponent(s))
	let l = b.length

	if (l < 10) {
		return s
	}

	let i = b.substr(0, 7)
	let f = b.substr(l - 3)

	let n = b.replace(new RegExp('^' + i), '')
	n = n.replace(new RegExp(f + '$'), '')

	return n + 'yQ' + i + 'zP' + f
}

export function desofuscarJSON (n) {
	if (!n) {
		return
	}

	let l = n.length

	if (l < 10) {
		return JSON.parse(atob(n))
	}

	let i = n.substr(l - 12, 7)
	let f = n.substr(l - 3)

	let b = i + n.replace(new RegExp('yQ' + i + 'zP' + f + '$'), f)

	let s = decodeURIComponent(atob(b))

	return JSON.parse(s)
}

export function númeroEnLetrasYTextoConcordante (n, unx, ts, tp) {
	let t = n === 1 ? ts : tp
	let obj = {'n': '', 't': t}
	if (n === 1) {
		obj.n = unx
	} else if (n === 2) {
		obj.n = 'dos'
	} else if (n === 3) {
		obj.n = 'tres'
	} else if (n === 4) {
		obj.n = 'cuatro'
	} else if (n === 5) {
		obj.n = 'cinco'
	} else if (n === 6) {
		obj.n = 'seis'
	} else if (n === 7) {
		obj.n = 'siete'
	} else if (n === 8) {
		obj.n = 'ocho'
	} else if (n === 9) {
		obj.n = 'nueve'
	} else if (n === 10) {
		obj.n = 'diez'
	} else if (n === 11) {
		obj.n = 'once'
	} else if (n === 12) {
		obj.n = 'doce'
	} else {
		obj.n = n
	}

	return obj
}

export function idAleatorio(l) {
	let r = ''
	let c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
	let L = c.length;
	for ( let i = 0; i < l; i++ ) {
			r += c.charAt(Math.floor(Math.random() * L))
	}
	return r
}

export function mayúsculaInicial(t) {
	let I = (t || '').substr(0,1).toUpperCase()
	return (t || '').replace(/^[a-zA-Z]/, I)
}